import { $applyNodeReplacement, setNodeIndentFromDOM } from "lexical";
import { ReferenceNode } from "./ReferenceNode.js";
const $createReferenceNode = ()=>$applyNodeReplacement(new ReferenceNode());
const $isReferenceNode = (node)=>node instanceof ReferenceNode;
const $convertReferenceElement = (element)=>{
    const node = $createReferenceNode();
    if (element.style) {
        node.setFormat(element.style.textAlign);
        setNodeIndentFromDOM(element, node);
    }
    return {
        node
    };
};
export { $convertReferenceElement, $createReferenceNode, $isReferenceNode };
